import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[copyToClipboard]'
})
export class CopyToClipboardDirective {

  constructor() { }

  @Input('copyToClipboard') text: string;

  @HostListener('click', ['$event'])
  onClick(e) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = this.text;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

}
